// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__PFofX","modal":"modal_modal__LJf9E","form":"modal_form__CXinZ","label":"modal_label__l858Y"};